import { render, staticRenderFns } from "./eventcool.vue?vue&type=template&id=70477be2"
import script from "./eventcool.vue?vue&type=script&lang=js"
export * from "./eventcool.vue?vue&type=script&lang=js"
import style0 from "./eventcool.vue?vue&type=style&index=0&id=70477be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports